/**
 * Kendo Material tema listesi
 * public/kendo-themes/ klasöründen statik URL ile servis edilir.
 * applyKendoTheme() ile <link> elementi üzerinden dinamik olarak uygulanır.
 */

const BASE = "/kendo-themes";

/** @type {{ id: string, label: string, dark: boolean, url: string }[]} */
export const KENDO_THEMES = [
  { id: "material-main",         label: "Material",        dark: false, url: `${BASE}/material-main.css` },
  { id: "material-main-dark",    label: "Material Dark",   dark: true,  url: `${BASE}/material-main-dark.css` },
  { id: "material-2",            label: "Material 2",      dark: false, url: `${BASE}/material-2.css` },
  { id: "material-2-dark",       label: "Material 2 Dark", dark: true,  url: `${BASE}/material-2-dark.css` },
  { id: "material-aqua-dark",    label: "Aqua Dark",          dark: true,  url: `${BASE}/material-aqua-dark.css` },
  { id: "material-arctic",       label: "Arctic",             dark: false, url: `${BASE}/material-arctic.css` },
  { id: "material-burnt-teal",   label: "Burnt Teal",         dark: false, url: `${BASE}/material-burnt-teal.css` },
  { id: "material-eggplant",     label: "Eggplant",           dark: false, url: `${BASE}/material-eggplant.css` },
  { id: "material-lime",         label: "Lime",               dark: false, url: `${BASE}/material-lime.css` },
  { id: "material-lime-dark",    label: "Lime Dark",          dark: true,  url: `${BASE}/material-lime-dark.css` },
  { id: "material-nova",         label: "Nova",               dark: false, url: `${BASE}/material-nova.css` },
  { id: "material-pacific",      label: "Pacific",            dark: false, url: `${BASE}/material-pacific.css` },
  { id: "material-pacific-dark", label: "Pacific Dark",       dark: true,  url: `${BASE}/material-pacific-dark.css` },
  { id: "material-sky",          label: "Sky",                dark: false, url: `${BASE}/material-sky.css` },
  { id: "material-sky-dark",     label: "Sky Dark",           dark: true,  url: `${BASE}/material-sky-dark.css` },
  { id: "material-smoke",        label: "Smoke",              dark: false, url: `${BASE}/material-smoke.css` },
];

// App dark/light modunda otomatik kullanılacak tema
export const DEFAULT_DARK_THEME  = "material-main-dark";
export const DEFAULT_LIGHT_THEME = "material-main";

const LINK_ID = "kendo-theme-dynamic";

/**
 * Kendo tema CSS'ini DOM <link> olarak inject eder.
 * Daha önce inject edilmiş varsa href'i değiştirir.
 */
export const applyKendoTheme = (themeId) => {
  const theme = KENDO_THEMES.find((t) => t.id === themeId);
  if (!theme) return;

  let link = document.getElementById(LINK_ID);
  if (!link) {
    link = document.createElement("link");
    link.id = LINK_ID;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = theme.url;
  console.debug("[KendoTheme] Applied:", themeId, "→", theme.url);
};
